import { Avatar, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

import StripedListItem from '../../Common/StripedListItem';
import DownloadListItemStatus from './downloadListItemStatus';
import DownloadListItemActions from './downloadListItemActions';
import { formatUtils } from '../formatUtils';

import { usePromiseStatus } from '../../../Lib/UI/Hooks/usePromiseStatus';
import { useInstantNotifier } from '../../../Lib/Notifier/useInstantNotifier';
import { ITileCacheSeederActions, ITileCacheSeedOperation } from '../../MapComponents/TileCache/types';

import uiStyles from "../../../Lib/UI/UI.module.css";


interface DownloadMapDataListItemProps {
    seederActions: ITileCacheSeederActions;
    item: ITileCacheSeedOperation;
}

const DownloadMapDataListItem = (props: DownloadMapDataListItemProps): JSX.Element => {

    const actionStatus = usePromiseStatus<ITileCacheSeedOperation>();
    const notifier = useInstantNotifier();

    const remove = (op: ITileCacheSeedOperation) => {
        const actionPromise = props.seederActions.removeOperation(op.id);
        actionPromise
            .then(() => notifier.success("Download removed"))
            .catch((error) => notifier.error("Failed to remove download", error));
        actionStatus.setPromise(actionPromise);
    };

    const cancel = (op: ITileCacheSeedOperation) => {
        const actionPromise = props.seederActions.cancelOperation(op.id);
        actionPromise
            .then(() => notifier.success("Download cancelled"))
            .catch((error) => notifier.error("Failed to cancel download", error));
        actionStatus.setPromise(actionPromise);
    };

    return (
        <StripedListItem
            secondaryAction={
                <DownloadListItemActions 
                    seederActions={props.seederActions}
                    op={props.item} 
                    onRemove={remove}
                    onCancel={cancel}
                    disabled={actionStatus.isBusy}
                />
            }
        >
            <ListItemAvatar>
                <Avatar 
                    variant="square" 
                    sx={{ width: { xs: 150, sm: 150, md: 200 }, 
                    height: { xs: 150, sm: 150, md: 200 }}} 
                    slotProps={{ img: { sx: { height: 'auto', width: 'auto', maxHeight: '100%', maxWidth: '100%' } } }} 
                    src={props.item.thumbUrl ?? undefined}
                >
                    <DownloadIcon fontSize="large" />
                </Avatar>
            </ListItemAvatar>

            <ListItemText 
                className={uiStyles.list_status}
                disableTypography
                primary={<Typography fontSize={{ xs: 15, md: 20 }}>{formatUtils.formatOperationStatusLong(props.item)}</Typography>}
                secondary={<DownloadListItemStatus op={props.item}/>}
            />

        </StripedListItem>
    );
};

export default DownloadMapDataListItem;